import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Data from '../../classes/Candidate'
// import serverEndPoint from './../../dxdm';
const box = {
    display: 'flex',
    margin: "5%"
}
const sideBoxes = {
    height: "170pt",
    width: "100%",
    backgroundColor: "rgb(233,241,246)",
    margin: "2%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}
const buttonCSS = { borderRadius: "20pt", textAlign: "center", width: "100%" }
export default class NewsandEvents extends Component {

    render() {
        return (
            <div>
            <h1 style={{ textAlign: "left", paddingTop: "2%", paddingLeft: "2%", color: "#286DB5" }}>News and Events</h1>

                <div className="row" style={{ width: "100%" }}>
                    <div className="col-sm-8" style={{ margin: "2%" }}>
                        {
                            Data.map(post => {
                                return (
                                    <div style={{ display: 'flex' }}>
                                        <div style={box}>
                                            <div style={{ textAlign: "left",paddingRight:"5%" }}>
                                                <h3 style={{ color: 'rgb(40,108,180)' }}>{post.heading}</h3>
                                                <p> {post.info}</p>
                                                {
                                                    post.webLink !== '' && post.webLink !== undefined &&
                                                    <a rel="noreferrer" target="_blank" href={post.webLink} style={{borderRadius:"100pt",marginTop:"5pt",paddingLeft:"5%",paddingRight:"5%"}} className="btn btn-primary">FIND OUT MORE</a>
                                                }
                                                {
                                                    post.videoLink !== '' && post.videoLink !== undefined &&
                                                    <a rel="noreferrer" target="_blank" href={post.videoLink} style={{borderRadius:"100pt",marginTop:"5pt",paddingLeft:"5%",paddingRight:"5%"}} className="btn btn-primary">WATCH VIDEO</a>
                                                }
                                            </div>
                                            <div >
                                                <img height={post.height} width={post.width} src={post.pic} alt="images"></img>
                                                
                                                
                                            </div>
                                            
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="col-sm-3" >
                        <br/>
                        <br/>
                        <div style={sideBoxes}>
                            <div style={{ padding: "7%" }}>
                                <h3 style={{ color: "rgb(40,109,181)" }}>Our Team</h3>
                                <p>Learn about the areas of research and methodologies used by the Data Science Research Group.</p>
                                <Link className="btn btn-primary" to={`/our-people`} style={buttonCSS}> <b>FIND OUT MORE</b> </Link>
                                {/* <Link className="btn btn-primary" to={`${serverEndPoint}/our-people`} style={buttonCSS}> <b>FIND OUT MORE</b> </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}
